import { AppointmentEntity } from 'backend-entity';

export type UpdateAppointmentPayload = Pick<AppointmentEntity, 'status' | 'description' | 'approvedDate'>;
